import "lazysizes";
import "picturefill";

if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}
document.addEventListener("DOMContentLoaded", function () {
  window.scrollTo(0, 0);
});

$('a[href^="#"]').click(function () {
  const speed = 500;
  const href = $(this).attr("href");
  const target = $(href == "#" || href == "" ? "html" : href);
  let position;
  if (window.matchMedia("(max-width: 835px)")) {
    position = target.offset().top - 0;
  } else {
    position = target.offset().top;
  }
  $("html, body").animate({ scrollTop: position }, speed, "swing");
  return false;
});

document.querySelectorAll('a[href*="#service"]').forEach((link) => {
  link.addEventListener("click", function (e) {
    e.preventDefault(); 
    const href = this.getAttribute("href");
    const hash = href.split("#")[1];
    if (hash) {
      sessionStorage.setItem("scrollToHash", hash);
      window.location.href = "/"; 
    }
  });
});


//アコーディオン
$(".js-menu__item__link").each(function () {
  $(this).on("click", function () {
    $("+.system__box,+.system__box--s,+.que__box", this).slideToggle();
    $(this).toggleClass("is-active");
    return false;
  });
});

//ヘッダーメニュー
$(".header__btn").on("click", function () {
  $("html").toggleClass("scroll-prevent");
  if ($(this).hasClass("is-active")) {
    $(this).removeClass("is-active");
    $("#nav-list").slideUp();
  } else {
    $(this).addClass("is-active");
    $("#nav-list").slideDown();
  }
});

window.addEventListener('DOMContentLoaded', () => {
  const fg = document.getElementById("particles-foreground");
  if (fg) {
    particleground(fg, {
      dotColor: "rgba(6, 105, 219, 0.3)",
      lineColor: "rgba(6, 105, 219, 0.1)",
      minSpeedX: 0.3,
      maxSpeedX: 0.6,
      minSpeedY: 0.3,
      maxSpeedY: 0.6,
      density: 50000,
      curvedLines: false,
      proximity: 250,
      parallaxMultiplier: 10,
      particleRadius: 10,
    });
  }

  const mv = document.getElementById("particles-mv");
  if (mv) {
    particleground(mv, {
      dotColor: "rgba(220, 220, 220, 1)",
      lineColor: "rgba(220, 220, 220, 0.5)",
      minSpeedX: 0.1,
      maxSpeedX: 0.2,
      minSpeedY: 0.1,
      maxSpeedY: 0.2,
      density: 15000,
      curvedLines: false,
      proximity: 200,
      parallaxMultiplier: 8,
      particleRadius: 8,
      parallax: false,
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".parallax-img");
  new simpleParallax(images, {
    scale: 1.5,
    delay: 0.5,
    transition: "cubic-bezier(0,0,0,1)",
  });
});

let currentScroll = 0;
let targetScroll = 0;

function smoothScrollUpdate() {
  currentScroll += (targetScroll - currentScroll) * 0.1;

  applyJoinEffect(currentScroll);

  requestAnimationFrame(smoothScrollUpdate);
}

$(window).on("scroll", function () {
  targetScroll = $(this).scrollTop();
});

requestAnimationFrame(smoothScrollUpdate);

function applyJoinEffect(scrollTop) {
  const windowHeight = $(window).height();
  const isSP = window.innerWidth <= 834;

  const $target = $(".about__container");
  if (!$target.length) return; 

  const targetTop = $target.offset().top;
  const targetHeight = $target.outerHeight();

  const start = targetTop - windowHeight + 300;
  const end = targetTop + targetHeight - 800;

  const baseSize = isSP ? 200 : 400;
  const maxSize = isSP ? 750 : 1300;

  let size;

  if (scrollTop >= start && scrollTop <= end) {
    const progress = (scrollTop - start) / (end - start);
    size = baseSize + (maxSize - baseSize) * progress;
  } else if (scrollTop < start) {
    size = baseSize;
  } else {
    size = maxSize;
  }

  $(".about__circle").css({
    width: size + "px",
    height: size + "px",
  });

  var $joinTarget = $(".join__container");
  var $joinCircle = $(".join__circle");
  var $joinBg = $(".join__bg");

  var joinTop = $joinTarget.offset().top;
  var joinHeight = $joinTarget.outerHeight();

  var joinStart = isSP
    ? joinTop - windowHeight + 300
    : joinTop - windowHeight + 300;  
  var joinEnd = isSP ? joinTop + joinHeight - 700 : joinTop + joinHeight - 900;  

  var minScale = 1.5;
  var maxScale = isSP ? 2 : 2.1;

  var bgProgress;
  if (scrollTop >= joinStart && scrollTop <= joinEnd) {
    bgProgress = (scrollTop - joinStart) / (joinEnd - joinStart);
  } else if (scrollTop < joinStart) {
    bgProgress = 0;
  } else {
    bgProgress = 1;
  }

  var bgScale = minScale + (maxScale - minScale) * bgProgress;

  var clipStart = isSP
    ? [30, 0, 100, 0, 70, 100, 0, 100]
    : [15, 0, 100, 0, 85, 100, 0, 100];
  var clipEnd = [0, 0, 100, 0, 100, 100, 0, 100];

  function interpolateClip(start, end, t) {
    return start.map((v, i) => v + (end[i] - v) * t);
  }

  var clipPoints = interpolateClip(clipStart, clipEnd, bgProgress)
    .map((v, i) => `${v}%`)
    .reduce((acc, cur, i) => acc + (i % 2 === 0 ? cur : " " + cur + ", "), "")
    .slice(0, -2);

  $joinBg.css({
    transform: `scale(${bgScale})`,
    "clip-path": `polygon(${clipPoints})`,
  });

  const circleMinScale = 1.3;
  const circleMaxScale = 1.6;

  const circleScale =
    circleMinScale + (circleMaxScale - circleMinScale) * bgProgress;

  $joinCircle.css({
    transform: `scale(${circleScale})`,
    "transform-origin": "center center",
  });

  const $blur = $(".about__blur");
  const blurTop = $blur.offset().top;
  const blurHeight = $blur.outerHeight();

  const blurStart = blurTop - windowHeight + 300;
  const blurEnd = blurTop + blurHeight - 1200;

  let blurOpacity;
  if (scrollTop >= blurStart && scrollTop <= blurEnd) {
    const progress = (scrollTop - blurStart) / (blurEnd - blurStart);
    blurOpacity = Math.min(Math.max(progress, 0), 1); 
  } else if (scrollTop < blurStart) {
    blurOpacity = 0;
  } else {
    blurOpacity = 1;
  }

  $blur.css("opacity", blurOpacity);
}

document.addEventListener("DOMContentLoaded", function () {
  const cursor = document.getElementById("cursor-follower");
  const trail = document.getElementById("cursor-trail");
  const joinCursor = document.getElementById("cursor-join");
  const joinContainer = document.querySelector(".join__container");

  const isSP = window.innerWidth <= 834;
  if (isSP) {
    if (cursor) cursor.style.display = "none";
    if (trail) trail.style.display = "none";
    if (joinCursor) joinCursor.style.display = "none";
    return;
  }

  let mouseX = 0,
    mouseY = 0;
  let currentX1 = 0,
    currentY1 = 0; 
  let currentX2 = 0,
    currentY2 = 0;

  document.addEventListener("mousemove", function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  function isInJoinContainer(x, y) {
    if (!joinContainer) return false;

    const rect = joinContainer.getBoundingClientRect();
    const isInsideRect =
      x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;

    if (!isInsideRect) return false;

    const elementAtPoint = document.elementFromPoint(x, y);
    return joinContainer.contains(elementAtPoint);
  }

  function animate() {
    const speed1 = 0.1;
    currentX1 += (mouseX - currentX1) * speed1;
    currentY1 += (mouseY - currentY1) * speed1;
    cursor.style.left = currentX1 + "px";
    cursor.style.top = currentY1 + "px";

    const speed2 = 0.08;
    currentX2 += (mouseX - currentX2) * speed2;
    currentY2 += (mouseY - currentY2) * speed2;
    trail.style.left = currentX2 + "px";
    trail.style.top = currentY2 + "px";

    const isOverJoin = isInJoinContainer(mouseX, mouseY);

    if (isOverJoin) {
      joinCursor.classList.add("is-visible");
      joinCursor.style.left = mouseX + "px";
      joinCursor.style.top = mouseY + "px";

      cursor.style.display = "none";
      trail.style.display = "none";
    } else {
      joinCursor.classList.remove("is-visible");

      cursor.style.display = "block";
      trail.style.display = "block";
    }

    requestAnimationFrame(animate);
  }

  animate();
});

document.querySelectorAll(".business__item").forEach((item, index) => {
  item.addEventListener("mouseenter", () => {
    item.parentElement.classList.add(`is-hover-${index + 1}`);
  });
  item.addEventListener("mouseleave", () => {
    item.parentElement.classList.remove(`is-hover-${index + 1}`);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const loading = document.getElementById("loading");
  const header = document.getElementById("header");
  const mvLogo = document.getElementById("mv__logo");

  if (!loading) return;

  const showMvAnimations = () => {
    document
      .querySelectorAll(".mv__title")
      .forEach((el) => el.classList.add("is-show"));
    document
      .querySelectorAll(".mv__text")
      .forEach((el) => el.classList.add("is-show"));
    header.classList.add("is-show");
    mvLogo.classList.add("is-show");
  };

  const hash = sessionStorage.getItem("scrollToHash");
  if (hash) {
    loading.style.display = "none";
    showMvAnimations();    
    const target = document.getElementById(hash);
    if (target) {
      const rect = target.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const offsetTop = rect.top + scrollTop;

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
    sessionStorage.removeItem("scrollToHash");
  } else {
    setTimeout(() => {
      loading.classList.add("hide");
      setTimeout(() => {
        loading.style.display = "none";
        showMvAnimations();
      }, 1000);
    }, 2000);  
  }
});

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-show");
        observer.unobserve(entry.target); 
      }
    });
  },
  {
    rootMargin: "-300px 0px",
    threshold: 0,
  }
);

document.querySelectorAll(".scroll").forEach((el) => observer.observe(el));

const observerSlow = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-show");
        observer.unobserve(entry.target);
      }
    });
  },
  {
    rootMargin: "0px 0px -500px 0px",
    threshold: 0,
  }
);
document
  .querySelectorAll(".scroll-slow")
  .forEach((el) => observerSlow.observe(el));

$(function () {
  var $hamburger = $("#js-hamburger");
  var $menu = $("#js-menu");
  var $menuBg = $("#js-menu-bg");
  var openingClass = "is-open";
  var isOpened = false;

  function openDrawer() {
    isOpened = true;
    $hamburger.addClass(openingClass);
    $menu.addClass(openingClass);
    $menuBg.addClass(openingClass);
  }

  function closeDrawer() {
    isOpened = false;
    $hamburger.removeClass(openingClass);
    $menu.removeClass(openingClass);
    $menuBg.removeClass(openingClass);
  }

  $hamburger.on("click", function () {
    if (isOpened) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".head").forEach(el => {
    el.classList.add("is-show");
  });
});

$(function () {
  $(".wpcf7-list-item-label").replaceWith(function () {
    $(this).replaceWith(
      `<span></span><p><a class="wpcf7-list-item-label" href="${pathUrl}/policy" target="_blank">` +
        $(this).text() +
        `<img src="${pathSrc}/img/common/external-link.svg" alt=""/></a>について同意する`
    );
  });
});